import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import content from '../../i18n/content';
import './Footer.css';

export default function Footer() {
  const { lang } = useLanguage();
  const t = content[lang].footer;
  const rights = t.rights.replace('{year}', new Date().getFullYear());

  return (
    <footer className="site-footer">
      <p>{rights}</p>
    </footer>
  );
}
